const map = {
  webp: "/media/contact/PFLEGER BAUSERVICE MAP.webp",
  jpg: "/media/contact/PFLEGER BAUSERVICE MAP.jpg",
  href: "https://maps.app.goo.gl/Awk63nm2ico6UM1X8",
};

export default map;
